"use client";
import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import { component } from "@gnist/component-utils";
import "../../../../building-blocks/inputs/internal/TextBelowInput.js";
import "../../../../foundation/iconography/ExtraIconsProvider.js";
import "../../../../foundation/iconography/IconVariantProvider.js";
import "../../../../foundation/iconography/icons.js";
import "../../../../foundation/iconography/Icon.js";
import "../../../../foundation/typography/index.js";
import "react";
import "classnames";
import "../../../../foundation/logos/Logo.css.js";
import "@gnist/themes/atoms.css.js";
import { TextSkeleton } from "../../../../building-blocks/skeletons/TextSkeleton.js";
import "@gnist/themes/tokens.css.js";
import "react-content-loader";
import { RectangularSkeleton } from "../../../../building-blocks/skeletons/RectangularSkeleton.js";
import "../../../../utilities/layout/Column.js";
import { Row } from "../../../../utilities/layout/Row.js";
import { cardDescription, SelectionControlSkeletonRecipe } from "./SelectionCard.css.js";
const SelectionCardLoader = ({ type, density }) => jsxs(Fragment, { children: [jsxs(Row, { gap: "base", verticalAlign: "baseline", children: [jsx(RectangularSkeleton, { className: SelectionControlSkeletonRecipe({ type }) }), jsx(TextSkeleton, {})] }), jsx("div", { children: jsx(CardDescription, { density, children: jsx(TextSkeleton, {}) }) })] });
const CardDescription = component("CardDescription", cardDescription, "span");
const SelectionCardContent = ({ description, value, density, children }) => {
  const [animationParent] = useAutoAnimate();
  if (!(description || children)) {
    return null;
  }
  return jsx(Fragment, { children: jsxs("div", { ref: animationParent, children: [description && jsx(CardDescription, { density, children: description }), value && children && jsx(CardDescription, { density, children })] }) });
};
export {
  SelectionCardContent,
  SelectionCardLoader
};
